export default __webpack_public_path__ + "static/media/Uganda4-Introduction0060.13fa81dc.JPG";